/* eslint-disable @typescript-eslint/no-shadow */
import { storyblokEditable } from '@storyblok/react';
import Image from 'next/image';
import { FC, ReactNode } from 'react';

import Container from '@/components/elements/Container';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface HeroBasicProps {
  children?: ReactNode;
  story: any;
  blok: any;
  pre_headline?: string;
  headline?: string;
  content?: string;
  actions: [];
  large_heading?: string;
  gapBottom?: string;
  image?: object;
  video?: object;
}

// const calculateMinHeight = (height, range) => {
//   return height + height * range;
// };

const HeroBio: FC<HeroBasicProps> = ({
  children,
  blok,
  pre_headline = blok.hero_pre_heading,
  headline = blok.hero_heading,
  content = blok.hero_content,
  actions = blok.actions,
}) => {
  return (
    <Section
      gapTop=""
      gapBottom={blok.background?.filename ? 'lg' : 'none'}
      className={`relative flex flex-col ${
        blok.header_theme === 'dark' ? 'bg-theme-black' : 'bg-white'
      } ${
        blok.background?.filename
          ? 'max-h-[1000px] sm:min-h-[800px] md:h-[calc(100vh-var(--notification-height))]'
          : null
      }`}
      {...storyblokEditable(blok)}
    >
      {children}
      <Container size={'wide'}>
        <div className="grid place-content-center gap-16 pt-16 sm:h-[900px] lg:grid-cols-2">
          <div className="order-2 sm:self-center lg:order-1">
            <StandardText
              blok={{ headline, pre_headline, content, actions }}
              size={StandardTextSize.ML}
            />
          </div>
          <div className="relative order-1 min-h-[60vh] lg:order-2 lg:min-h-[900px]">
            {blok.background?.filename && (
              <Image
                alt={blok.background?.alt || ''}
                src={blok.background?.filename}
                fill
                sizes="100vw"
                className="object-contain mix-blend-multiply"
              />
            )}
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default HeroBio;
